module.exports = __webpack_public_path__ + "static/phn-logo-d83cc048f70c9ee7df2a56c7ee9f7475.svg";